import { render, staticRenderFns } from "./productDirectoryInfo.vue?vue&type=template&id=2fb5e1f0&scoped=true"
import script from "./productDirectoryInfo.vue?vue&type=script&lang=js"
export * from "./productDirectoryInfo.vue?vue&type=script&lang=js"
import style0 from "./productDirectoryInfo.vue?vue&type=style&index=0&id=2fb5e1f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb5e1f0",
  null
  
)

export default component.exports